"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "oggebbio": {
    "e19a3cd2": [{
      "hkey": "dc5888ec",
      "slug": "gonte",
      "name": "Gonte",
      "primary": true,
      "skipSearch": false
    }],
    "cadessino": [{
      "hkey": "dc5888ec",
      "slug": "gonte",
      "name": "Gonte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "oggebbio"
    }],
    "b08f91a5": [{
      "hkey": "ad0b0712",
      "slug": "oggebbio",
      "name": "Oggebbio",
      "primary": true,
      "skipSearch": false
    }],
    "cadivecchio": [{
      "hkey": "ad0b0712",
      "slug": "oggebbio",
      "name": "Oggebbio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "04cb81ad": [{
      "hkey": "ad0b0712",
      "slug": "oggebbio",
      "name": "Oggebbio",
      "primary": true,
      "skipSearch": false
    }],
    "dumera": [{
      "hkey": "ad0b0712",
      "slug": "oggebbio",
      "name": "Oggebbio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "15462cd0": [{
      "hkey": "dc5888ec",
      "slug": "gonte",
      "name": "Gonte",
      "primary": true,
      "skipSearch": false
    }],
    "gonte-capoluogo": [{
      "hkey": "dc5888ec",
      "slug": "gonte",
      "name": "Gonte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "1a031ff6": [{
      "hkey": "ad0b0712",
      "slug": "oggebbio",
      "name": "Oggebbio",
      "primary": true,
      "skipSearch": false
    }],
    "manegra": [{
      "hkey": "ad0b0712",
      "slug": "oggebbio",
      "name": "Oggebbio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6e072c28": [{
      "hkey": "ad0b0712",
      "slug": "oggebbio",
      "name": "Oggebbio",
      "primary": true,
      "skipSearch": false
    }],
    "mozzola": [{
      "hkey": "ad0b0712",
      "slug": "oggebbio",
      "name": "Oggebbio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "490a5c7a": [{
      "hkey": "ad0b0712",
      "slug": "oggebbio",
      "name": "Oggebbio",
      "primary": true,
      "skipSearch": false
    }],
    "piazza": [{
      "hkey": "ad0b0712",
      "slug": "oggebbio",
      "name": "Oggebbio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "65f2cd4d": [{
      "hkey": "ad0b0712",
      "slug": "oggebbio",
      "name": "Oggebbio",
      "primary": true,
      "skipSearch": false
    }],
    "pieggio": [{
      "hkey": "ad0b0712",
      "slug": "oggebbio",
      "name": "Oggebbio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a08e8040": [{
      "hkey": "dc5888ec",
      "slug": "gonte",
      "name": "Gonte",
      "primary": true,
      "skipSearch": false
    }],
    "quarcino": [{
      "hkey": "dc5888ec",
      "slug": "gonte",
      "name": "Gonte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "oggebbio"
    }],
    "fed6c869": [{
      "hkey": "dc5888ec",
      "slug": "gonte",
      "name": "Gonte",
      "primary": true,
      "skipSearch": false
    }],
    "rancone": [{
      "hkey": "dc5888ec",
      "slug": "gonte",
      "name": "Gonte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "oggebbio"
    }],
    "591070bd": [{
      "hkey": "ad0b0712",
      "slug": "oggebbio",
      "name": "Oggebbio",
      "primary": true,
      "skipSearch": false
    }],
    "spasolo": [{
      "hkey": "ad0b0712",
      "slug": "oggebbio",
      "name": "Oggebbio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a070de6d": [{
      "hkey": "ad0b0712",
      "slug": "oggebbio",
      "name": "Oggebbio",
      "primary": true,
      "skipSearch": false
    }],
    "travallino": [{
      "hkey": "ad0b0712",
      "slug": "oggebbio",
      "name": "Oggebbio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;